export default "__VITE_ASSET__9ZbnrM9p__"